import { ComponentStyleConfig, defineStyle } from '@chakra-ui/react'

const variants = {
    adminCardWrapper: defineStyle(({ theme }) => {
        const colors = theme.colors

        return {
            pt: '12px',
            pb: '9px',
            px: '15px',
            bgColor: colors.beige.darkened,
            minH: '168px',
            borderRadius: '8px',
        }
    }),
    cardWrapperNarrow: defineStyle(({ theme }) => {
        const colors = theme.colors

        return {
            py: '9px',
            px: '12px',
            bgColor: colors.beige.darkened,
            borderRadius: '8px',
            minH: 'auto',
        }
    }),
}

export const CardWrapperTheme: ComponentStyleConfig = {
    baseStyle: {
        borderRadius: '15px',
        padding: '26px',
        backgroundColor: 'white',
    },
    variants,
}
